import { type AgentModelPickerProps } from '@apps/web/components/phoebe_chat/agent_model_picker';
import {
    type AgentTestMode,
    type RawToolDescriptionMode,
} from '@apps/web/components/phoebe_chat/agent_test_mode';
import {
    V3AgentModelPicker,
    V3AgentTestModePicker,
} from '@apps/web/features/phoebe_chat_v3/ui/model_picker';

export type V3AgentToolbarProps = AgentModelPickerProps & {
    readonly agentTestMode: AgentTestMode;
    readonly rawToolDescriptions: RawToolDescriptionMode;
    readonly allowParallelAgentTestMode: boolean;
    readonly agentTestModeDisabled: boolean;
    readonly onAgentTestModeChange: (mode: AgentTestMode) => void;
    readonly onRawToolDescriptionsChange?: (
        mode: RawToolDescriptionMode,
    ) => void;
    readonly showAgentTestModeControl: boolean;
};

export function V3AgentToolbar({
    pinnedModel,
    resolvedModel,
    disabled,
    onModelChange,
    agentTestMode,
    rawToolDescriptions,
    allowParallelAgentTestMode,
    agentTestModeDisabled,
    onAgentTestModeChange,
    onRawToolDescriptionsChange,
    showAgentTestModeControl,
}: V3AgentToolbarProps) {
    return (
        <div className="flex min-w-0 flex-wrap items-center gap-2">
            <V3AgentModelPicker
                pinnedModel={pinnedModel}
                resolvedModel={resolvedModel}
                disabled={disabled}
                onModelChange={onModelChange}
            />
            {showAgentTestModeControl ? (
                <V3AgentTestModePicker
                    mode={agentTestMode}
                    rawToolDescriptions={rawToolDescriptions}
                    allowParallel={allowParallelAgentTestMode}
                    disabled={disabled || agentTestModeDisabled}
                    onModeChange={onAgentTestModeChange}
                    onRawToolDescriptionsChange={onRawToolDescriptionsChange}
                />
            ) : null}
        </div>
    );
}
